<template>
  <div id="training-set-image-classification">

    <div class="container">

      <div class="page-title">
        <span class="name">Classification (ensemble d'entraînement)</span>
      </div>
      <Panel :showTitle="false">
        <div class="columns" style="margin-bottom: 20px; margin-top: 20px">
          <div class="column">
            <div>Filtres</div>
            <select v-model="filterTodo" style="width: 100%">
              <option v-bind:value="true">{{ $t('todo') }}</option>
              <option v-bind:value="false">{{ $t('all') }}</option>
            </select>
          </div>
          <div class="column">
            <div>Branche</div>
            <select v-model="selectedBranchId" style="width: 100%">
              <option :value="branch.id" v-for="branch of branches">{{ branch.name }}</option>
            </select>
          </div>
          <div class="column">
            <div>Compagnie</div>
            <select v-model="selectedInventoryId" style="width: 100%">
              <option :value="company.inventory" v-for="company of companies">{{ company.name }}</option>
            </select>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <ImageCarousel ref="carousel" v-if="ready" :focusedIndex="focusedIndex" :items="items" :disabledNext="true"
              v-on:indexChanged="indexChanged"></ImageCarousel>
          </div>
          <div class="column">
            <div style="display: flex; margin-bottom: 20px">
              <div style="flex-grow: 1">
                Item : {{ hasFocusedItem ? (focusedItem.training.done ? 'Fait' : 'À faire') : '---' }}
              </div>
              <div style="flex-grow: 1">
                Image : {{ hasFocusedImage ? (focusedImage.training.done ? 'Fait' : 'À faire') : '---' }}
              </div>
            </div>
            <div>
              <input type="checkbox" id="chk_exclude_from_image_classification" v-model="excludeFocusImage"
                :disabled="!hasFocusedItem">
              <label for="chk_exclude_from_image_classification">Exclure l'image de la classification</label>
            </div>
            <div style="margin-bottom: 20px">
              <input type="checkbox" id="chk_exclude_from_recommender_system" v-model="excludeFocusItem"
                :disabled="!hasFocusedItem">
              <label for="chk_exclude_from_recommender_system">Exclure le produit du recommender system</label>
            </div>
            <div class="group">
              <input type="text" v-model="searchClass.search" class="highlight-on-focus" ref="searchInput"
                @keydown.up="searchInputOnUpOrDown(-1)" @keydown.down="searchInputOnUpOrDown(1)"
                @keyup.enter="searchInputOnEnter" @keyup="searchInputOnKeyUp" @focus="searchInputOnFocus(true)"
                @blur="searchInputOnFocus(false)">
              <ul class="autocomplete-results" v-if="searchClass.focused">
                <li :data-class="result.class" :data-subclass="result.subclass" v-for="result of searchClass.results"
                  class="autocomplete-result" ref="searchResults" @click="onSearchSelected">{{ result.name }}</li>
              </ul>
            </div>
            <select v-model="focusedTrainingClass" class="highlight-on-focus" style="width: 100%">
              <option :value="clazz.id" v-for="clazz of classes">{{ clazz.name }}</option>
            </select>
            <select v-model="focusedTrainingSubClass" class="highlight-on-focus" style="width: 100%">
              <option :value="subClass.id" v-for="subClass of subClassesOfSelectedClass">{{ subClass.name }}</option>
            </select>
            <button class="btn btn-primary highlight-on-focus" @click="jumpNext" ref="nextButton"
              style="margin-top: 25px; width: 100%">Prochain</button>
            <div style="display: flex; margin-top: 25px">
              <button class="btn btn-primary highlight-on-focus" @click="popAddClassModal">Ajouter Catégorie</button>
              <div style="flex-grow: 1"></div>
              <button class="btn btn-primary highlight-on-focus" @click="popAddSubClassModal"
                style="margin-left: 5px">Ajouter Sous-catégorie</button>
            </div>
          </div>
        </div>
        <div style="margin-top: 30px">
          <div style="font-weight: bold" v-if="recentLog.length > 0">Logs</div>
          <div v-for="line of recentLog">{{ line.msg }}</div>
        </div>
      </Panel>

    </div>

    <Modal name="error-modal" :title="errorModal.title" :actions="[{ name: $t('back'), action: 'close' }]">
      {{ this.errorModal.errors.join(',') }}
    </Modal>

    <Modal name="add-class" title="Ajouter une catégorie"
      :actions="[{ name: $t('back'), action: 'close' }, { name: $t('save'), action: addClassFromModal, primary: true }]">
      <div class="group">
        <label>Catégorie</label>
        <input type="text" v-model="newClassification.class">
      </div>
    </Modal>

    <Modal name="add-subclass" title="Ajouter une sous-catégorie"
      :actions="[{ name: $t('back'), action: 'close' }, { name: $t('save'), action: addClassFromModal, primary: true }]">
      <div class="group">
        <label>Catégorie</label>
        <select v-model="newClassification.class">
          <option :value="clazz.id" v-for="clazz of classes">{{ clazz.name }}</option>
        </select>
      </div>
      <div class="group">
        <label>Sous-catégorie</label>
        <input type="text" v-model="newClassification.subClass">
      </div>
    </Modal>

  </div>
</template>

<script>
  import ImageCarousel from '@/components/tools/ImageCarousel.vue';
  import { Core } from '@/core/Core';

  export default {
    name: "TrainingSetImageClassification",

    components: { ImageCarousel },

    data() {
      return {
        ready: false,
        errorModal: {
          title: "",
          errors: []
        },
        selectedBranchId: null,
        branches: [{
          id: 0,
          name: ''
        }],
        selectedInventoryId: null,
        companies: [{
          id: 0,
          name: '',
          inventory: 0
        }],
        filterTodo: true,
        focusedIndex: null,
        items: [{
          id: 0,
          name: { fr: '' },
          image: null,
          url: null,
          training: {
            class: null,
            subClass: null,
            excluded: false,
            done: false
          }
        }],
        images: [{
          id: 0,
          url: "",
          training: {
            class: null,
            subClass: null,
            excluded: false,
            done: false
          }
        }],
        searchClass: {
          focused: false,
          search: "",
          results: []
        },
        classes: [{
          id: 'id',
          name: 'name',
          subClasses: [{
            id: 'id',
            name: 'name'
          }]
        }],
        recentLog: [],
        newClassification: {
          class: null,
          subClass: null
        }
      }
    },
    mounted() {
      this.$store.commit("showSpinner", true);
      Promise
        .all([
          Core.request("GET", '/api/entity/branch/select'),
          Core.request("GET", '/api/training-classes')
        ])
        .then(([branches, trainingClasses]) => {
          this.images = [];
          this.companies = [];
          this.branches = branches;
          this.setClasses(trainingClasses)
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.$store.commit("showSpinner", false)
        });
    },
    methods: {
      searchInputOnUpOrDown(relative) {
        let refs = this.$refs.searchResults;
        let index = -1;
        for (let i = 0; i < refs.length - 1; i++) {
          if (refs[i].classList.contains('focused')) {
            refs[i].classList.remove('focused');
            index = i;
            break;
          }
        }
        if (index + relative >= 0) {
          refs[index + relative].classList.add('focused')
        }
      },
      searchInputOnFocus(focused) {
        //because autoComplete's @blur trigger before autoCompleteResult's @click
        setTimeout(() => { this.searchClass.focused = focused }, 0);
      },
      searchInputOnEnter() {
        let tmp = this.$refs.searchResults.filter(x => x.classList.contains('focused'));
        if (tmp.length > 0) {
          tmp[0].click()
        }
      },
      searchInputOnKeyUp() {
        let search = this.searchClass.search.toLowerCase();
        let results = [];
        if (search !== "") {
          for (let clazz of this.classes) {
            for (let subClass of clazz.subClasses) {
              if (subClass.name.toLowerCase().includes(search)) {
                results.push({
                  class: clazz.id,
                  subclass: subClass.id,
                  name: `${clazz.name} - ${subClass.name}`
                })
              }
            }
          }
        }
        this.searchClass.results = results
      },
      onSearchSelected(e) {
        this.focusedTrainingClass = e.currentTarget.dataset.class;
        this.focusedTrainingSubClass = e.currentTarget.dataset.subclass;
        this.searchClass.search = e.currentTarget.innerHTML;
        this.$refs.nextButton.focus();
      },
      jumpNext() {
        if ((this.focusedTrainingClass && this.focusedTrainingSubClass) || (this.excludeFocusImage && this.excludeFocusItem)) {
          this.$refs.carousel.focusNext()
        } else {
          this.errorModal.title = "Erreur";
          this.errorModal.errors = ["Vous devez sélectionner exclude le produit ou sélectionner une classification avant de pouvoir continuer"];
          this.$modal.show("error-modal");
        }
      },
      focusOnSearchInput() {
        this.searchClass = {
          search: "",
          results: []
        };
        this.$refs.searchInput.focus();
      },
      setClasses(trainingClasses) {
        this.classes = Object.keys(trainingClasses).map(c => ({
          id: c,
          name: this.$t(`classification.categories.${c}`).replace('classification.categories.', ''),
          subClasses: trainingClasses[c].map(subClass => ({
            id: subClass,
            name: this.$t(`classification.categories.${subClass}`).replace('classification.categories.', ''),
          }))
        }));
      },
      popAddClassModal() {
        this.newClassification = {
          class: "",
          subClass: ""
        };
        this.$modal.show("add-class");
      },
      popAddSubClassModal() {
        this.newClassification = {
          class: this.focusedTrainingClass,
          subClass: ""
        };
        this.$modal.show("add-subclass");
      },
      addClassFromModal() {
        this.$modal.show("add-class", false);
        this.$modal.show("add-subclass", false);
        let className = this.newClassification.class;
        let subClassName = this.newClassification.subClass;
        if (!className || className === "") {
          this.errorModal.title = "Erreur";
          this.errorModal.errors = ["Le nom de la catégorie ne doit pas être vide."];
          this.$modal.show("error-modal");
          return;
        }
        let data = {};
        data[className] = [subClassName];
        this.$store.commit("showSpinner", true);
        Core.request("PUT", '/api/training-classes', data)
          .then(trainingClasses => {
            this.setClasses(trainingClasses)
          })
          .catch(e => {
            console.log(e);
          })
          .finally(() => {
            this.$store.commit("showSpinner", false);
          });
      },
      submitToTrainingSet(items, images) {
        let data = {
          items: items.map(item => ({
            id: item.id,
            class: item.training.class,
            subClass: item.training.subClass,
            excluded: item.training.excluded
          })),
          images: images.map(image => ({
            id: image.id,
            class: image.training.class,
            subClass: image.training.subClass,
            excluded: image.training.excluded
          }))
        };
        Core.request("PUT", '/api/training-set/ishop', data)
          .then(response => {
            for (let item of items) {
              item.training.done = item.training.done || response.done;
            }
            for (let image of images) {
              image.training.done = image.training.done || response.done
            }
            if (response.errors.length > 0) {
              this.errorModal.title = "Erreur de synchronisation avec le serveur python";
              this.errorModal.errors = response.errors;
              this.$modal.show("error-modal");
            } else {
              for (let item of items) {
                let parts = [];
                if (item.training.class) {
                  parts.push(item.training.class)
                }
                if (item.training.subClass) {
                  parts.push(item.training.class)
                }
                if (item.training.excluded) {
                  parts.push(item.training.excluded ? 'excluded' : '')
                }
                this.recentLog = [{ msg: `${this.$to(item.name)} (${item.id}). ${parts.join(' - ')}` }]
                  .concat(this.recentLog.slice(0, 9));
              }
            }
          })
          .catch(e => {
            console.log(e);
          })
      },
      indexChanged(newValue, oldValue) {
        this.focusedIndex = newValue;
        this.focusOnSearchInput();
        if (oldValue !== null) {
          let item = this.items[oldValue];
          let image = this.findImageById(item.image);
          this.submitToTrainingSet([item], image ? [image] : []);
        }
      },
      findImageById(imageId) {
        return imageId ? this.images.filter(i => i.id === imageId)[0] : null
      }
    },
    computed: {
      subClassesOfSelectedClass() {
        if (this.focusedTrainingClass) {
          let classes = this.classes.filter(c => c.id === this.focusedTrainingClass);
          return classes.length > 0 ? classes[0].subClasses : [];
        }
        return []
      },
      focusedItem() {
        return this.focusedIndex !== null ? this.items[this.focusedIndex] : null
      },
      hasFocusedItem() {
        return this.focusedItem !== null
      },
      focusedImage() {
        return this.focusedItem ? this.findImageById(this.focusedItem.image) : null
      },
      hasFocusedImage() {
        return this.focusedImage !== null
      },
      excludeFocusImage: {
        get() {
          return this.focusedImage !== null ? this.focusedImage.training.excluded : false
        },
        set(isExcluded) {
          if (this.focusedImage) {
            this.focusedImage.training.excluded = isExcluded
          }
        }
      },
      excludeFocusItem: {
        get() {
          return this.focusedItem !== null ? this.focusedItem.training.excluded : false
        },
        set(isExcluded) {
          if (this.focusedItem) {
            this.focusedItem.training.excluded = isExcluded
          }
        }
      },
      focusedTrainingClass: {
        get() {
          return this.focusedItem ? this.focusedItem.training.class : null
        },
        set(clazz) {
          if (this.focusedItem) {
            this.focusedItem.training.class = clazz
          }
          if (this.focusedImage) {
            this.focusedImage.training.class = clazz
          }
        }
      },
      focusedTrainingSubClass: {
        get() {
          return this.focusedItem ? this.focusedItem.training.subClass : null
        },
        set(subClass) {
          if (this.focusedItem) {
            this.focusedItem.training.subClass = subClass
          }
          if (this.focusedImage) {
            this.focusedImage.training.subClass = subClass
          }
        }
      },
    },
    watch: {
      selectedBranchId: function (branchId) {
        this.$store.commit("showSpinner", true);
        Core.request("GET", '/api/entity/company/select', { branch: branchId, add: 'inventory' })
          .then(companies => {
            this.companies = companies.map(c => ({
              id: c.id,
              name: c.name,
              inventory: c.inventory
            }));

            if (this.companies.length === 1) {
              this.selectedInventoryId = this.companies[0].inventory
            }
          })
          .catch(e => {
            console.log(e);
          })
          .finally(() => {
            this.$store.commit("showSpinner", false)
          })
      },
      selectedInventoryId: function (inventoryId) {
        this.$store.commit("showSpinner", true);
        Promise
          .all([
            Core.request('GET', `/api/inventory/${inventoryId}/items`),
            Core.request('GET', `/api/inventory/${inventoryId}/images`, { augment: 'training' })
          ])
          .then(([items, images]) => {
            this.images = images
              .map(image => ({
                id: image.id,
                url: image.url,
                training: {
                  class: image.training.class || null,
                  subClass: image.training.subClass || null,
                  excluded: image.training.excluded || false,
                  done: image.training.done || false
                }
              }));
            this.items = items
              .filter(i => !this.filterTodo || !i.training.done)
              .map(item => ({
                id: item.id,
                name: item.name,
                description: item.description,
                image: item.image,
                url: item.image ? this.findImageById(item.image).url : null,
                training: {
                  class: item.training.class || null,
                  subClass: item.training.subClass || null,
                  excluded: item.training.excluded || false,
                  done: item.training.done || false
                }
              }));

            this.focusedIndex = this.items.length > 0 ? 0 : null;
            this.ready = true;
            this.focusOnSearchInput();
          })
          .catch(e => {
            console.log(e);
          })
          .finally(() => {
            this.$store.commit("showSpinner", false)
          });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .highlight-on-focus:focus {
    background-color: lightskyblue;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover,
  .autocomplete-result.focused {
    background-color: #4AAE9B;
    color: white;
  }
</style>